/**
 * UISP is only reachable from the Flask backend. Use these helpers so all UISP-related
 * actions go through relative paths on API_CONFIG.baseUrl — never a UISP host in the browser.
 */
import { api, post } from "./api";

export const requestUispDeviceRestart = (body) => post("/uisp/device_restart", body);

/** POST /uisp/speed_test/start — UISP device internet speed test (see uisp-swagger Speed Test). */
export const startUispSpeedTest = (body) => post("/uisp/speed_test/start", body);

/** GET /uisp/speed_test/status — poll running test detail. */
export const fetchUispSpeedTestStatus = (deviceId, testId) => {
  const q = new URLSearchParams({
    device_id: String(deviceId),
    test_id: String(testId),
  });
  return api.get(`uisp/speed_test/status?${q.toString()}`);
};

/** POST /uisp/speed_test/stop — cancel running test. */
export const stopUispSpeedTest = (body) => post("/uisp/speed_test/stop", body);

/** POST /uisp/speed_test/record — save terminal test result to uisp_speedtest. */
export const recordUispSpeedTest = (body) => post("/uisp/speed_test/record", body);

/** GET /uisp/speed_test/history — saved tests for customer + CPE IP. */
export const fetchUispSpeedTestHistory = ({ customer_id, cpe_ip, limit = 50 }) => {
  const q = new URLSearchParams({
    customer_id: String(customer_id),
    cpe_ip: String(cpe_ip),
    limit: String(limit),
  });
  return api.get(`uisp/speed_test/history?${q.toString()}`);
};
